import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import Select from "react-select";
import "./CreateRole.css";
import axios from 'axios';
import { ring } from 'ldrs'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Cookies from 'js-cookie';
import { decryptData } from "../../../Auth/cryptage";




const CreateRole = () => {
    const [permissions, setPermissions] = useState([]);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState({
        who:'',
        status:false
    });
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    ring.register()

    const back = () => {
        navigate(-1);
    };

    const getPermissionsData = async () => {
        try {
            setLoading({
                who: 'permissions',
                status: true,
                userId: null
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/permissions', {
                headers: {
                    'X-Custom-Token': token
                }
            });
            // console.log()(result.data.permissions);
            if(!result.data.permissions){
                setPermissions([]);
            }else{
                setPermissions(result.data.permissions);
            }
        } catch (error) {
            console.error("Error fetching users: ", error);
            setLoading({
                who: 'permissions',
                status: false,
                userId: null
            });
        } finally {
            setLoading({
                who: 'permissions',
                status: false,
                userId: null
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading({
                who:"submit",
                status:true
            });
            const token = decryptData(Cookies.get('access_token'));
            const formData = new FormData(e.target);
            const roleName = formData.get('role_name');
            const selectedPermissions = formData.getAll('permissions');
            console.log(roleName);
            console.log(selectedPermissions);
            const req ={
                name: roleName,
                permissions: selectedPermissions
            };
            await axios.post('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/create-role', req , {
                headers: {
                    'X-Custom-Token': token
                }
            });
            MySwal.fire({
                title: "Success!",
                text: "Permission created successfully",
                icon: "success"
            });
            navigate(-1);
        } catch (err) {
            setLoading({
                who:"submit",
                status:false
            });
            MySwal.fire({
                title: "Error!",
                text: err.message,
                icon: "error"
            });
            // console.log()(err.message);
        }finally{
            setLoading({
                who:"submit",
                status:false
            });
        }
    };

    useEffect(() => {
        getPermissionsData();
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Ajouter un role";
    }, []);

    useEffect(() => {
        if (Array.isArray(permissions) && permissions.length > 0) {
            setOptions(permissions.map((permission) => ({
                value: permission.id,
                label: `${permission.name}`
            })));
        } else {
            setOptions([]);
        }
    }, [permissions]);
    

    return (
        <Container className="d-flex align-items-center justify-content-center mb-4 mr-0 ml-0">
            <Col className="justify-content-center ">
                <Row className="justify-content-center w-100 ">
                    <Col xs={12} md={8} lg={6}>
                        <div className="form-container">
                            <h3 className="createRoleTitle text-center mb-5">Créer un Role</h3>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4 w-100" controlId="role_name">
                                    <Form.Label>Nom de role</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className=" fs-6"
                                        name="role_name"
                                        placeholder='Saisi nom de role'
                                        size="lg"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4 w-100 text-center" controlId="multi_select">
                                    <Form.Label>Les permissions</Form.Label>
                                    {
                                        loading.status && loading.who ==="permissions" ?
                                        (
                                            <Select
                                                name="permissions"
                                                options={options}
                                                isMulti
                                                placeholder={<l-ring
                                                                size="30"
                                                                stroke="3"
                                                                bg-opacity="0"
                                                                speed="2" 
                                                                color="black" 
                                                            ></l-ring>}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        ):
                                        (
                                            <Select
                                                name="permissions"
                                                options={options}
                                                isMulti
                                                placeholder="Choisissez les permissions"
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        )
                                    }
                                </Form.Group>
                                <Button
                                    className="mb-4 w-100 gradient-custom-4"
                                    size="lg"
                                    type="submit"
                                >
                                    {loading.status && loading.who ==="submit" ? (
                                            <l-ring-2
                                                size="25"
                                                stroke="3"
                                                stroke-length="0.25"
                                                bg-opacity="0.1"
                                                speed="0.8"
                                                color="white"
                                            ></l-ring-2>
                                        ):(
                                            'créer'
                                        )}
                                </Button>
                                <Button className="backbtn btn-danger mb-4 w-100" onClick={back} size="lg">
                                    <BsArrowLeft className="btnbackIcon" />
                                    Back
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Container>
    );
};

export default CreateRole;
